import axios from 'axios';

// Crear instancia
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api` || 'https://back.thestablegame.com/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar el token dinámicamente
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken'); // O usa un contexto global
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Manejo de token expirado o no autorizado
      console.error('Token inválido o expirado. Redirigiendo al login...');
      window.location.href = '/login'; // Cambia según tu ruta de login
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
